import { render, staticRenderFns } from "./AddressItem.vue?vue&type=template&id=9c00d5ae&"
import script from "./AddressItem.vue?vue&type=script&lang=js&"
export * from "./AddressItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports